import { startAppleOAuth, startGoogleOAuth } from "../oauthStart";
import { AppleLogoIcon, GoogleLogoIcon } from "./OAuthProviderIcons";

type Props = {
  googleEnabled: boolean;
  appleEnabled: boolean;
  loading: boolean;
  error: string | null;
  ariaLabel: string;
};

export function OAuthProviderButtons({ googleEnabled, appleEnabled, loading, error, ariaLabel }: Props) {
  const noneConfigured = !loading && !googleEnabled && !appleEnabled;

  return (
    <div className="card oauth-below">
      <p className="muted oauth-divider">Or continue with</p>
      {error ? <p className="error">{error}</p> : null}
      {noneConfigured ? (
        <p className="muted mb-0">
          Google and Apple sign-in are not configured on this server. Use email and password, or ask the admin to set
          OAuth secrets.
        </p>
      ) : null}
      <div className="oauth-inline-row" role="group" aria-label={ariaLabel}>
        <button
          type="button"
          className="oauth-icon-btn"
          disabled={loading || !googleEnabled}
          title={!googleEnabled && !loading ? "Google sign-in is not configured" : undefined}
          onClick={() => startGoogleOAuth()}
        >
          <GoogleLogoIcon />
          <span>Google</span>
        </button>
        <button
          type="button"
          className="oauth-icon-btn"
          disabled={loading || !appleEnabled}
          title={!appleEnabled && !loading ? "Apple sign-in is not configured" : undefined}
          onClick={() => startAppleOAuth()}
        >
          <AppleLogoIcon />
          <span>Apple</span>
        </button>
      </div>
    </div>
  );
}
